import Menu from './menu-list'

Menu.install = function (Vue) {
    Vue.component(Menu.name,Menu)
}
export default Menu
